<template>
  <div class="donut">
    <svg class="donut__svg" viewBox="0 0 120 120" role="img" :aria-label="ariaLabel">
      <circle class="donut__track" cx="60" cy="60" :r="R" :stroke-width="THICK" />
      <circle
        v-for="arc in arcs"
        :key="arc.label"
        class="donut__arc"
        cx="60"
        cy="60"
        :r="R"
        :stroke="arc.color"
        :stroke-width="THICK"
        :stroke-dasharray="`${arc.length} ${CIRC}`"
        :stroke-dashoffset="-arc.offset"
        transform="rotate(-90 60 60)"
      >
        <title>{{ arc.label }} {{ arc.value }}건</title>
      </circle>
      <text class="donut__total" x="60" y="56">{{ total.toLocaleString('ko-KR') }}</text>
      <text class="donut__unit" x="60" y="72">{{ centerLabel }}</text>
    </svg>

    <ul class="donut__legend">
      <li v-for="arc in arcs" :key="`lg-${arc.label}`">
        <router-link
          v-if="arc.to"
          :to="arc.to"
          class="donut__row is-link"
        >
          <span class="donut__swatch" :style="{ background: arc.color }" />
          <span class="donut__label">{{ arc.label }}</span>
          <strong class="donut__value">{{ arc.value.toLocaleString('ko-KR') }}</strong>
          <span class="donut__pct">{{ arc.percent }}%</span>
        </router-link>
        <div v-else class="donut__row">
          <span class="donut__swatch" :style="{ background: arc.color }" />
          <span class="donut__label">{{ arc.label }}</span>
          <strong class="donut__value">{{ arc.value.toLocaleString('ko-KR') }}</strong>
          <span class="donut__pct">{{ arc.percent }}%</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

export interface DonutSlice {
  label: string
  value: number
  color: string
  /** 클릭 시 이동할 경로(쿼리 포함) */
  to?: string
}

const props = withDefaults(
  defineProps<{
    slices: DonutSlice[]
    centerLabel?: string
    ariaLabel?: string
  }>(),
  {
    centerLabel: '건',
    ariaLabel: '구성 비율 그래프',
  },
)

const R = 48
const THICK = 16
const CIRC = 2 * Math.PI * R

const total = computed(() => props.slices.reduce((sum, slice) => sum + slice.value, 0))

const arcs = computed(() => {
  let offset = 0
  const sum = total.value || 1

  return props.slices.map((slice) => {
    const length = (slice.value / sum) * CIRC
    const arc = {
      ...slice,
      length,
      offset,
      percent: Math.round((slice.value / sum) * 100),
    }
    offset += length
    return arc
  })
})
</script>

<style lang="scss" src="./SellerDonutChart.scss"></style>
